import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ApiHomeService } from "../services/api-home.service";

export const apiHomeResolver: ResolveFn<Promise<ApiHome.RootObject>> = async () => {
  return inject(ApiHomeService).fetchApiHomeResource();
};
